const apiLogin= {
  // 12.02 登录（Web）
  goLogin: '/api/AccountManagement/Login',
}

export default apiLogin
